import Axios from 'axios';
import customAxios from './axios';
import * as types from './types';
import CONFIG from '../../config';

export const userData = (data) => ({
    type: types.USER_DATA,
    data
});

export const userAuthLogout = () => ({
    type: types.INIT_LOGOUT
});

export const userLogin = (payload) => {
    return Axios.post(CONFIG.apiURL + '/Auth/WebLogin', payload).then(response => {
        return response;
    });
};

export const userLogout = (payload) => {
    return Axios.post(CONFIG.apiURL + '/Auth/WebLogout', payload).then(response => {
        return response;
    });
};

export const userChangePassword = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Users/ChangePassword', payload).then(response => {
        return response;
    });
};

export const resetPassword = (userID) => {
    return customAxios.post(CONFIG.apiURL + `/User/ResetPassword?userId=${userID}`).then(response => {
        return response;
    });
};